module.exports = __webpack_public_path__ + "static/media/66_aluminium_metal_surface_seamless.343f56ed.jpg";